import _get from 'lodash/get';

export function selectActiveLocation(state) {
  return _get(state, 'eCommerce.activeLocation', {});
}
